import React from 'react';

import Text from 'components/shared/text';
import Container from 'components/shared/container';
import CssImplementation from 'components/shared/css-implementation';

const RuleExampleAttribute = () => (
  <Container width="80%" margin="20px auto">
    <Text
      fontSize="18px"
      textAlign="left"
      fontWeight="bold"
      margin="0 auto 10px 0"
      text="CSS Attribute Rule Example"
    />
    <Text
      lineHeight="2"
      textAlign="left"
      margin="0 auto 10px 0"
      text="Here we are targeting all Anchor elements title attribute and giving them a height of 200px."
    />
    <CssImplementation
      selectorName="a[title]"
      idForCopy="css-attribute-example"
      properties={[{ name: 'width', value: '200px' }]}
    />
  </Container>
);

export default RuleExampleAttribute;
